import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

import { NotificationHandleType } from "../components/Notifications";
import { InsuranceCoverageMonitoringContractorContext } from "../components/Notifications/templates/InsuranceCoverageMonitoringContractor";

export const selectorInsuranceCoverageMonitoringContractorNotifications = (
  responses: IChannelNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle ===
      NotificationHandleType.InsuranceCoverageMonitoringContractor
    );
  }) as Array<
    Omit<IChannelNotificationResponse, "context"> & {
      context: InsuranceCoverageMonitoringContractorContext;
    }
  >;
};
